<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">request_quote</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Estatus Cajero</h1>
    <span *ngIf="statusCajero.length > 0" class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
      {{ statusCajero.length }} registros
    </span>
  </div>
  <span *ngIf="statusCajero.length > 0" class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ statusCajero.length }} registros
  </span>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros
      </h2>
    </div>
    <div class="p-5">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Filtrar por Pa&iacute;s</mat-label>
          <mat-select [(ngModel)]="selectedPais" (selectionChange)="applyFilters()">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let pais of paises" [value]="pais">{{ pais }}</mat-option>
          </mat-select>
          <mat-icon matPrefix style="color: #6b7280;">public</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Filtrar por Banco</mat-label>
          <mat-select [(ngModel)]="selectedBanco" (selectionChange)="applyFilters()">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let banco of bancos" [value]="banco">{{ banco }}</mat-option>
          </mat-select>
          <mat-icon matPrefix style="color: #6b7280;">account_balance</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Filtrar por Moneda</mat-label>
          <mat-select [(ngModel)]="selectedMoneda" (selectionChange)="applyFilters()">
            <mat-option value="">Todas</mat-option>
            <mat-option *ngFor="let moneda of monedas" [value]="moneda">{{ moneda }}</mat-option>
          </mat-select>
          <mat-icon matPrefix style="color: #6b7280;">attach_money</mat-icon>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row gap-3 justify-end">
        <button type="button" (click)="clearFilters()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear_all</mat-icon>
          Limpiar Filtros
        </button>
        <button type="button" (click)="loadData()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">refresh</mat-icon>
          Recargar
        </button>
      </div>
    </div>
  </div>

  <!-- Card Tabla -->
  <div *ngIf="dataSource" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">table_chart</mat-icon>
        Status de Cajeros
      </h2>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" class="w-full">
        <!-- Cajero -->
        <ng-container matColumnDef="cajero">
          <th mat-header-cell *matHeaderCellDef style="min-width: 180px;">Cajero</th>
          <td mat-cell *matCellDef="let row" class="clickable-cell" (click)="onCajeroClick(row)">
            {{ row.cuenta.nombre }} {{ row.cuenta.apellidos }}
          </td>
        </ng-container>

        <!-- Banco -->
        <ng-container matColumnDef="banco">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Banco</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.cuenta.banco.nombre }}</td>
        </ng-container>

        <!-- Moneda -->
        <ng-container matColumnDef="moneda">
          <th mat-header-cell *matHeaderCellDef style="min-width: 80px;">Moneda</th>
          <td mat-cell *matCellDef="let row">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-800">{{ getCurrency(row.cuenta.banco.codigoPais) }}</span>
          </td>
        </ng-container>

        <!-- Balance en sistema -->
        <ng-container matColumnDef="balanceSistema">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Balance Sistema</th>
          <td mat-cell *matCellDef="let row" style="font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">
            {{ row.total | currency:'$' }}
          </td>
        </ng-container>

        <!-- Balance restante -->
        <ng-container matColumnDef="balance">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Balance Restante</th>
          <td mat-cell *matCellDef="let row" style="font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">
            {{ row.total - (row.necesarioOb + row.fiatOb + row.necesarioMb) | currency:'$' }}
          </td>
        </ng-container>

        <!-- Total -->
        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Total</th>
          <td mat-cell *matCellDef="let row" style="font-weight: 600; font-size: 0.8rem;">
            {{ row.necesarioOb + row.fiatOb + row.necesarioMb | currency:'$' }}
          </td>
        </ng-container>

        <!-- Necesario OB -->
        <ng-container matColumnDef="necesarioOB">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Necesario OB</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.necesarioOb | currency:'$' }}</td>
        </ng-container>

        <!-- Necesario MB -->
        <ng-container matColumnDef="necesarioMB">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Necesario MB</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.necesarioMb | currency:'$' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="getBlinkingClass(row)"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden p-4 space-y-3">
      <div *ngFor="let row of dataSource.filteredData; let i = index"
        class="bg-white rounded-xl border transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'"
        [ngClass]="getBlinkingClass(row)">
        <!-- Card Header -->
        <div class="flex items-center justify-between p-3 cursor-pointer" (click)="toggleCard(i)">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="text-sm font-semibold text-gray-800 truncate">{{ row.cuenta.nombre }} {{ row.cuenta.apellidos }}</span>
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-800">{{ getCurrency(row.cuenta.banco.codigoPais) }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span style="font-weight: 700; color: #1e5a3f; font-size: 0.85rem;">{{ row.total | currency:'$' }}</span>
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #6b7280; transition: transform 0.2s;"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">expand_more</mat-icon>
          </div>
        </div>
        <!-- Card Body -->
        <div *ngIf="expandedCardId === i" class="border-t border-gray-100 p-3">
          <div class="grid grid-cols-2 gap-3 text-sm mb-3">
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Banco</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ row.cuenta.banco.nombre }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Balance Restante</span>
              <p style="font-weight: 700; color: #1e5a3f; margin-top: 2px;">{{ row.total - (row.necesarioOb + row.fiatOb + row.necesarioMb) | currency:'$' }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Total Asignado</span>
              <p class="text-gray-800 font-semibold mt-0.5">{{ row.necesarioOb + row.fiatOb + row.necesarioMb | currency:'$' }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Necesario OB</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ row.necesarioOb | currency:'$' }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Necesario MB</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ row.necesarioMb | currency:'$' }}</p>
            </div>
          </div>
          <div class="flex gap-2 pt-2 border-t border-gray-100">
            <button type="button" (click)="onCajeroClick(row); $event.stopPropagation()"
              style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">visibility</mat-icon>
              Ver Detalle
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
